import React from 'react';

export const ShowMoreButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button 
      onClick={onClick}
      className="w-full flex justify-center items-center bg-transparent p-0 cursor-pointer"
    >
      <div className="border-[0px_0px_1px] border-black border-solid box-border content-center flex flex-wrap gap-[4px] items-center justify-end relative">
        <p className="font-['Nunito'] font-bold leading-[1.4] relative shrink-0 text-[14px] text-black text-nowrap whitespace-pre">
          Show more
        </p>
        <svg className="overflow-clip relative shrink-0 size-[14px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </button>
  );
};

export const ShowLessButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button 
      onClick={onClick}
      className="w-full flex justify-center items-center bg-transparent p-0 cursor-pointer"
    >
      <div className="border-[#21272a] border-[0px_0px_1px] border-solid box-border content-center flex flex-wrap gap-[4px] items-center justify-end relative">
        <p className="font-['Nunito'] font-bold leading-[1.4] relative shrink-0 text-[#21272a] text-[14px] text-nowrap whitespace-pre">
          Show less
        </p>
        <div className="flex items-center justify-center relative shrink-0">
          <div className="flex-none scale-y-[-100%]">
            <svg className="overflow-clip relative size-[14px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </button>
  );
};
